export default __webpack_public_path__ + "static/media/shopping-cart.6e627af0.png";